export default __webpack_public_path__ + "img/d3ef5f02bbeb6fd7b5204b7bf968d45e.svg";